import Request from "../helpers/request-v2"

export default class CepRequest {

    static cache = {}

    static search(cep) {

        const strippedCep = cep.replace(/-|_/g, '')
        const url = `https://viacep.com.br/ws/${strippedCep}/json/`

        if (strippedCep.length !== 8)
            return Promise.resolve(null)

        if (CepRequest.cache[cep])
            return Promise.resolve(CepRequest.cache[cep])


        return Request
            .getInstance()
            .createGetRequest(url, {}, {}, false, false)
            .then(result => {
                CepRequest.cache[cep] = result
                return result
            })


    }
}


// WEBPACK FOOTER //
// ./src/requests/cep-request.js